$(function () {
    if (window.innerWidth >= 640) {
        $('.content img').each(function (i, e) {
            if (!$(e).hasClass('m-image--featured__img')) {
                $(e).attr('data-src', $(e).attr('src'));
                $(e).attr('src', null);
            }
        });
        $('.content img').lazy({
            effect: "fadeIn",
            effectTime: 1000,
            threshold: 0
        });
    }
});

jQuery(document).ready(function () {

    // media query event handler
    var breakpoint;

    if (matchMedia) {
        const mq = window.matchMedia("(min-width: 640px)");
        mq.addListener(WidthChange);
        WidthChange(mq);
    }

    // media query change
    function WidthChange(mq) {
        if (mq.matches) {
            // window width is at least 640px
            breakpoint = 'large';
        } else {
            // window width is less than 640px
            breakpoint = 'small';
        }
    }

    if (jQuery('.m-panel__content--center .m-tag-list li').length === 1) {
        jQuery('.m-panel__content--center .m-tag-list li').css('margin-right', 0);
    }

    jQuery('[name="akID[36][value]"]').closest('label').css('font-size', '1.1rem').css('line-height', 0.7);

    // Search
    var siteLogo = jQuery('.m-logo').find('img').attr("src");
    var burgerIcon = jQuery('.mmm-burger').find('img').attr("src");
    var searchIcon = jQuery('.m-search-icon').find('img').attr("src");

    if (jQuery('.m-news-related-posts .m-news-excerpt').length === 0) {
        jQuery('.m-news-related-posts').remove();
    }

    jQuery('figure span.arrow-scroll').click(function () {
        jQuery("html, body").animate({scrollTop: jQuery('.js-off-canvas-overlay').height()}, 1000);
    });

    jQuery('.m-search-icon').click(function () {

        if (typeof searchOverlay !== 'undefined' && searchOverlay == true) {
            searchOverlay = false;
        } else {
            searchOverlay = true;
        }

        if (searchOverlay == true) {
            jQuery('.m-search-overlay').addClass('on');
            jQuery('.m-search-icon').find('img').attr("src", "/application/themes/hlp2018/assets/svg/icon-close-rev.svg");
            jQuery('.m-logo').find('img').attr("src", "/application/themes/hlp2018/assets/images/hlp-logo-rev.png");
            jQuery('.mmm-burger').find('img').attr("src", "/application/themes/hlp2018/assets/svg/icon-burger-rev.svg");
            jQuery('.m-site-search__input').focus();
        } else {
            jQuery('.m-search-overlay').removeClass('on');
            jQuery('.m-search-icon').find('img').attr("src", searchIcon);
            jQuery('.m-logo').find('img').attr("src", siteLogo);
            jQuery('.mmm-burger').find('img').attr("src", burgerIcon);
        }
    });

    document.onkeydown = function (evt) {
        evt = evt || window.event;
        var isEscape = false;
        if ("key" in evt) {
            isEscape = (evt.key == "Escape" || evt.key == "Esc");
        } else {
            isEscape = (evt.keyCode == 27);
        }
        if (isEscape) {
            jQuery('#off-canvas').removeClass('is-open').addClass('is-closed');

            jQuery('.m-search-overlay').removeClass('on');
            jQuery('.m-search-icon').find('img').attr("src", searchIcon);
            jQuery('.m-logo').find('img').attr("src", siteLogo);
            jQuery('.mmm-burger').find('img').attr("src", burgerIcon);
        }
    };

    if (jQuery('.content .m-image-group').length === 0 && jQuery('.content .m-image-gallery').length === 0) {
        jQuery('.content .m-panel').addClass('no-gallery');
        jQuery('.m-image-text-panel').addClass('no-gallery');
        jQuery('.m-panel.no-gallery:eq(1)').addClass('last');
    } else if (jQuery('.content .m-image-gallery').length === 0) {
        jQuery('.content .m-panel').addClass('no-gallery');
        jQuery('.m-image-group').addClass('no-gallery');
        jQuery('.m-panel.no-gallery:eq(1)').addClass('last');
    }

    jQuery('form [type="submit"]').addClass('m-btn m-btn--cta m-btn--submit');

    // Team Grid
    jQuery('.m-team-grid__block').click(function () {
        if(jQuery(this).attr('data-link')) {
            window.location = jQuery(this).attr('data-link');
            return;
        }
        var teamPhoto = jQuery(this).find('.m-team-grid__image').attr("src");
        var teamName = jQuery(this).attr('data-team-name');
        var teamJob = jQuery(this).attr('data-team-job');
        var teamBio = jQuery(this).attr('data-team-bio');
        var linkedIn = jQuery(this).attr('data-linkedin');
        var linkedInHTML = '';

        if (linkedIn) {
            linkedInHTML = "<p><a class='m-btn' href='" + linkedIn + "'><i class='icon-social icon-linkedin'></i></a></p>";
        }

        jQuery('.m-team-grid__caption').removeClass('current');
        jQuery(this).find('.m-team-grid__caption').addClass('current');
        jQuery('.m-team-grid__profile').addClass('active');

        if (breakpoint === 'large') {
            jQuery('.m-team-grid__profile').html("<img class=\"m-team-grid__profile__photo\" src=" + teamPhoto + " /><div class=\"m-team-grid__profile__id\"><h3 class=\"m-team-grid__profile__name\">" + teamName + "</h3>" + "<h4 class=\"m-team-grid__profile__job\">" + teamJob + "</h4></div>" + "<div class=\"m-team-grid__profile__bio\"><p>" + teamBio + "</p>" + linkedInHTML + "</div>");
        } else {
            jQuery('.m-team-grid__profile').html("<div class=\"m-team-grid__profile__id\"><h3 class=\"m-team-grid__profile__name\">" + teamName + "</h3>" + "<h4 class=\"m-team-grid__profile__job\">" + teamJob + "</h4></div>" + "<div class=\"m-team-grid__profile__bio\"><p>" + teamBio + "</p>" + linkedInHTML + "</div>");

            jQuery('.m-team-grid__profile').insertAfter(jQuery(this));
        }

        jQuery("html, body").animate({scrollTop: jQuery('.m-team-grid:eq(0)').offset().top}, 1000);
    });

    if (window.innerWidth >= 1200) {
        if(jQuery('.m-image__shaper--16x9 img').length > 0) {
            let o = jQuery('.m-image__shaper--16x9 img').offset().top + jQuery('.m-image__shaper--16x9 img').outerHeight();
            let h = jQuery('h2.m-page-subheading').offset().top + jQuery('h2.m-page-subheading').outerHeight();
            let p = o - h;
            let n = jQuery('h2.m-page-subheading').outerHeight() + 40 + p;
            jQuery('h2.m-page-subheading').height(n);
        }
    }
});